import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditBookMutation } from "../redux/features/api/apiSlice";


export default function EditForm({ book }) {
    const navigate = useNavigate()
    const [editBook, { isLoading, isSuccess, isError }] = useEditBookMutation();
    const [input, setInput] = useState(book);



    useEffect(() => {
        if (isSuccess) navigate("/");
    }, [ isSuccess, navigate]);



    const submitHandler = (e) => {
        e.preventDefault();
        editBook({ id: book.id, data: input })
    }


    const inputHandler = (fieldName, e) => {
        switch (fieldName) {
            case "price":
                setInput({ ...input, [fieldName]: Number(e.target.value) })
                break;

            case "rating":
                setInput({ ...input, [fieldName]: Number(e.target.value) })
                break;

            case "featured":
                setInput((prev) => {
                    return { ...input, [fieldName]: !prev.featured }
                })
                break;

            default:
                setInput({ ...input, [fieldName]: e.target.value })
        }
    }

    return (
        <form className="book-form" onSubmit={submitHandler}>
            <div className="space-y-2">
                <label htmlFor="lws-bookName">Book Name</label>
                <input required className="text-input" type="text" id="lws-bookName" name="name"
                    value={input.name}
                    onChange={(e) => inputHandler("name", e)}
                />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-author">Author</label>
                <input required className="text-input" type="text" id="lws-author" name="author"
                    value={input.author}
                    onChange={(e) => inputHandler("author", e)}
                />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-thumbnail">Image Url</label>
                <input required className="text-input" type="text" id="lws-thumbnail" name="thumbnail"
                    value={input.thumbnail}
                    onChange={(e) => inputHandler("thumbnail", e)}
                />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
                <div className="space-y-2">
                    <label htmlFor="lws-price">Price</label>
                    <input required className="text-input" type="number" id="lws-price" name="price"
                        value={input.price}
                        onChange={(e) => inputHandler("price", e)}
                    />
                </div>

                <div className="space-y-2">
                    <label htmlFor="lws-rating">Rating</label>
                    <input required className="text-input" type="number" id="lws-rating" name="rating" min="1"
                        max="5"
                        value={input.rating}
                        onChange={(e) => inputHandler("rating", e)}
                    />
                </div>
            </div>

            <div className="flex items-center">
                <input id="lws-featured" type="checkbox" name="featured" className="w-4 h-4"
                    checked={input.featured}
                    onChange={() => inputHandler("featured")}
                />
                <label htmlFor="lws-featured" className="ml-2 text-sm"> This is a featured book </label>
            </div>

            <button type="submit" className="submit" id="lws-submit" disabled={isLoading}>Add Book</button>
            {isError && <div>There was an adding error</div>}
        </form>
    )
};